export type GTMDataLayer = Record<string, unknown>[];

export enum GTMEventNames {
  init = 'init',
  signup = 'sign_up',
  profileRegistration = 'profile_registration',
  cryptoTransaction = 'crypto_transaction',
}
